import { useQuery } from 'react-query';

import { api } from '../api';

export interface ICodMovAndType {
  type: "MAQ" | "ADM" | "ANT" | "LOC" | "OUT" | "PGE" | "TCC" | "TCD" | undefined;
}

interface ITransaction {
  origem: number;
  id: number;
  idContaEstabelecimento: number;
  idComprovante: number;
  dtMovimento: Date;
  vlMovimento: number;
  codMovimento: ICodMovAndType;
}

interface ITransactionDetail {
  idOrdemRepasse: string;
  numOrdem: number;
  serie: string;
  dtEmissao: string;
  parcela: number;
  vlBruto: number;
  dtPrevPgto: string;
  dtBaixa: string;
  vlBaixa: number;
  tipo: ICodMovAndType;
  produtoDescricao: string;
}

interface IExtractDetail {
  transacao: ITransaction;
  detalhe: ITransactionDetail[];
  total: number;
}

interface IParams {
  docto: string;
  id: string;
  pagina: number;
  limite: number;
}

export async function getDetalheExtrato(
  params: IParams
): Promise<IExtractDetail> {
  const { data } = await api.get('transactions/extratoDetalhe', { params });

  return {
    transacao: data.transacao,
    detalhe: data?.detalhe,
    total: data?.detalhe.length
  }
}

export function useDetalheExtrato(params: IParams) {
  return useQuery(['repasse-baixa', params.docto, params.id, params.pagina, params.limite], () => getDetalheExtrato(params), {
    staleTime: Infinity,
    enabled: String(api.defaults.headers.common.authorization).length > 10 && !!params.docto,
    retry: 2
  });
}
